export default {"src":"/_next/static/media/duplicate.3f1c995c.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};